import SentimentSatisfiedSharpIcon from '@material-ui/icons/SentimentSatisfiedSharp';

function GoodEmoji() {
  return (
    <SentimentSatisfiedSharpIcon
      style={{
        border: '1px solid black',
        background: '#228B22',
        fontSize: '36px',
        color: 'black',
      }}
    />
  );
}

export default GoodEmoji;
